import script from "./FilaComponente.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilaComponente.vue?vue&type=script&lang=ts&setup=true"

import "./FilaComponente.vue?vue&type=style&index=0&id=aafaf7a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aafaf7a2"]])

export default __exports__